import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { ViewportRect } from '@/utilities/viewportRect'

const useIframeStore = defineStore('iframeStore', () => {
  const iframeRef = ref<InstanceType<typeof HTMLIFrameElement> | undefined>(undefined)
  const isReady = ref(false)
  // True while a Frappe modal is open and the embedding iframe is expanded
  // over the whole viewport (see FrappeComponentIFrameWrapper). Components
  // floating over the iframe area (e.g. the bulk action menu) lift
  // themselves above the overlay while the dialog rect does not overlap them.
  const isModalOverlayActive = ref(false)
  const modalOverlayDialogRect = ref<null | ViewportRect>(null)

  return {
    iframeRef,
    isModalOverlayActive,
    isReady,
    modalOverlayDialogRect,
  }
})

export { useIframeStore }
